const ModuleType = Object.freeze({
  PARTICIPANT_PROFILE: 1,
  PARTICIPANT_CONTACT: 2,
  PARTICIPANT_ASSIGNMENT: 3,
  ACTIVITIES_SERVICES: 4,
  ASSESSMENT_OUTCOMES: 5,
  ORGANIZATION_GENERAL: 6,
  ORGANIZATION_ORGANIZATION: 7,
  MEMBER_PROFILE: 8,
  INDIVIDUAL_REFERRAL: 9,
  MEMBER_REFERRAL: 10,
});

export {ModuleType}




// WEBPACK FOOTER //
// ./src/enums/moduleType.js